export namespace CONSTANTS {

    export const APP_SESSION_KEY = 'app.session';
    export const DATE_FORMAT = 'DD/MM/YYYY';
    export const TIME_FORMAT = 'hh:mm a';

    export const DATA_PERU = [
        { index: 1, ubigeo: "010000", id: "PE-AMA", nombre_departamento: "AMAZONAS", seleccion: false },
        { index: 2, ubigeo: "020000", id: "PE-ANC", nombre_departamento: "ÁNCASH", seleccion: false },
        { index: 3, ubigeo: "030000", id: "PE-APU", nombre_departamento: "APURÍMAC", seleccion: false },
        { index: 4, ubigeo: "040000", id: "PE-ARE", nombre_departamento: "AREQUIPA", seleccion: false },
        { index: 5, ubigeo: "050000", id: "PE-AYA", nombre_departamento: "AYACUCHO", seleccion: false },
        { index: 6, ubigeo: "060000", id: "PE-CAJ", nombre_departamento: "CAJAMARCA", seleccion: false },
        { index: 7, ubigeo: "070000", id: "PE-CAL", nombre_departamento: "CALLAO", seleccion: false },
        { index: 8, ubigeo: "080000", id: "PE-CUS", nombre_departamento: "CUSCO", seleccion: false },
        { index: 9, ubigeo: "090000", id: "PE-HUV", nombre_departamento: "HUANCAVELICA", seleccion: false },
        { index: 10, ubigeo: "100000", id: "PE-HUC", nombre_departamento: "HUANUCO", seleccion: false },
        { index: 11, ubigeo: "110000", id: "PE-ICA", nombre_departamento: "ICA", seleccion: false },
        { index: 12, ubigeo: "120000", id: "PE-JUN", nombre_departamento: "JUNÍN", seleccion: false },
        { index: 13, ubigeo: "130000", id: "PE-LAL", nombre_departamento: "LA LIBERTAD", seleccion: false },
        { index: 14, ubigeo: "140000", id: "PE-LAM", nombre_departamento: "LAMBAYEQUE", seleccion: false },
        { index: 15, ubigeo: "150000", id: "PE-LIM", nombre_departamento: "LIMA", seleccion: false },
        { index: 16, ubigeo: "160000", id: "PE-LOR", nombre_departamento: "LORETO", seleccion: false },
        { index: 17, ubigeo: "170000", id: "PE-MDD", nombre_departamento: "MADRE DE DIOS", seleccion: false },
        { index: 18, ubigeo: "180000", id: "PE-MOQ", nombre_departamento: "MOQUEGUA", seleccion: false },
        { index: 19, ubigeo: "190000", id: "PE-PAS", nombre_departamento: "PASCO", seleccion: false },
        { index: 20, ubigeo: "200000", id: "PE-PIU", nombre_departamento: "PIURA", seleccion: false },
        { index: 21, ubigeo: "210000", id: "PE-PUN", nombre_departamento: "PUNO", seleccion: false },
        { index: 22, ubigeo: "220000", id: "PE-SAM", nombre_departamento: "SAN MARTÍN", seleccion: false },
        { index: 23, ubigeo: "230000", id: "PE-TAC", nombre_departamento: "TACNA", seleccion: false },
        { index: 24, ubigeo: "240000", id: "PE-TUM", nombre_departamento: "TUMBES", seleccion: false },
        { index: 25, ubigeo: "250000", id: "PE-UCA", nombre_departamento: "UCAYALI", seleccion: false },
    ];

    export const DEFAULT_MAP_OPTIONS: google.maps.MapOptions = {
        zoomControl: false,
        disableDoubleClickZoom: true,
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
    }

    export const MAX_INTEGER = 100000000;

}
